module.exports = __webpack_public_path__ + "img/logo-powerpoint.8b8dbea7.jpg";